<template>
  <div class="header-main">
    <div class="main-logo">
      <router-link :to="{name: 'mainPage'}">
        <img src="../../assets/logo.jpg" alt="Logo" />
      </router-link>
      <!-- <p class="header-info">
        Dział sprzedaży:
        <span class="header-number">(22) 726 50 50</span>
      </p>-->
    </div>

    <div v-if="this.$store.state.searchBlock" class="mobile-search">
      <SearchInput />
    </div>

    <div class="main-right" @click="calcAllBasketsNetValue">
      <div v-if="user" class="inner-right">
        <!-- <span class="header-separator"></span> -->
        <SearchInput />
        <span class="header-separator"></span>
        <div class="basket-container">
          <BasketIcon />
          <div class="basket-header-info" @click="goBasket">
            <div>
              <span>{{calcAllBasketsNetValue()}}</span>
            </div>
          </div>
        </div>
        <span class="header-separator"></span>
        <UserDropDownButton />

        <div class="menu-button-content">
          <div class="menu-button">
            <!-- <menu-icon title="open" @click.native="clickSmMenu" /> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import DropdownMenu from "./../layout/src/navigation/DropdownMenu";

import CategoriesIcons from "./../categories/src/CategoriesIcon";
import BrandsIcon from "./../brands-carousel/src/BrandsIcon";


import SearchInput from "./../layout/src/input/SearchInput";

import BasketIcon from "./../layout/src/button/BasketIcon.vue";
import UserDropDownButton from "./../layout/src/button/UserDropDownButton.vue";
import { storeEmitter } from "../../state/store";
import CalculatePrice from "../products/src/product/CalculatePrice";
import SubHeader from "./SubHeader";

export default {
  components: {
    DropdownMenu,
    CategoriesIcons,
    BrandsIcon,
    SearchInput,
    BasketIcon,
    UserDropDownButton,
    SubHeader
    // MenuIcon
  },
  computed: {
    ...mapState({
      user: state => state.user.authorizedUser,
      basket: state => state.basket.basket
    }),
    ...mapGetters({
      currency: "company/selectedCurrency"
    })
  },
  props: ["scrolled"],
  data() {
    return {
      logo: ""
    };
  },
  methods: {
    ...CalculatePrice(),
    clickSmMenu() {
      storeEmitter.emit("open-sm");
    },
    calcAllBasketsNetValue() {
      let totalPrice = 0;
      this.basket.baskets.forEach(element => {
        totalPrice += element.price_net;
      });
      return this.priceToString(totalPrice, this.currency().currency.symbol);
    },
    goBasket() {
      this.$router.push({ name: "cart" });
    }
  },
  beforeMount() {
    this.logo = this.$config.get("header.main.logo");
  }
};
</script>



// WEBPACK FOOTER //
// src/components/template/HeaderMain.vue